(function (window, $) {
  var $registrationContainer = $('#campaign-register-main');
  var $pickupStudioSelect = $registrationContainer.find('select[name=prize_pickup_studio_id]');
  this.viewedGoals = [];

  var addViewedGoal = function (selectedGoal) {
    if (this.viewedGoals.indexOf(selectedGoal) === -1) {
      this.viewedGoals.push(selectedGoal);
      this.viewedGoals.sort();
    }
  };

  var registerRider = function (form) {
    if (!$pickupStudioSelect.val()) {
      $pickupStudioSelect.addClass('field-error');
      confirmation(null, ('Please select your home studio.'));
      return;
    }
    if (form) {
      var formData = new FormData(form[0]);
      formData.append('viewed_goals', this.viewedGoals);
      formData.append('read_terms', !!this.readTerms);
    }

    $.ajax({
      url: '/warrior-week/register/',
      data: formData,
      type: 'post',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function (data) {
        var response = data.payload;
        // Check response for any errors
        if (response.error_message) {
          switch (response.error_field) {
          // Invalid prize pickup studio
          case 'prize_pickup_studio_id':
            $pickupStudioSelect.addClass('field-error');
            confirmation(null, response.error_message);
            break;
            // Rider not logged in.
          case 'rider':
            window.location.href = '/warrior-week/';
            break;
            // Rider already registered
          case 'registered':
            window.location.href = '/me/warrior-week/';
            break;
          default:
            confirmation(null, response.error_message);
          }
        } else {
          var eventData = {
            'Pledge Chosen': formData.get('goal_select'),
            'Pledges Viewed': formData.get('viewed_goals'),
            'Pledge Recommended': formData.get('recommended-goal'),
            'Studio Chosen': formData.get('prize_pickup_studio_id'),
            'Email Updates Checked': formData.get('email_opt_in') ? 'Y' : 'N',
            'Read Terms & Conditions': formData.get('read_terms') ? 'Y' : 'N'
          };
          SC.analytics.mp.logEvent('Challenge_Spring19 - Complete Register', 'navigation', eventData);

          // Route to confirmation
          window.location.href = '/me/warrior-week/';
        }
      },
      error: function () {
        confirmation(null, ('Could not fulfill this request.'));
      }
    });
  };

  $pickupStudioSelect.change(function () {
    $pickupStudioSelect.removeClass('field-error');
  });

  $registrationContainer.find('form.campaign-registration-form').submit(function (e) {
    e.preventDefault();
    var form = $(this);
    registerRider(form);
  });

  // Setup goal selector
  $registrationContainer.find('.js-goal-select').change(function () {
    var selectedGoal = $(this).val();
    var $input = $registrationContainer.find('.js-goal-radio[value=' + selectedGoal + ']');
    $input.prop('checked', true);
    $input.change();
    addViewedGoal(selectedGoal);
  });

  $registrationContainer.find('.js-goal-radio').change(function () {
    var $input = $(this);
    var selectedGoal = $input.val();

    if ($input.parents('.selected-goal').length) {
      return;
    }

    $registrationContainer.find('.recommended-goal-tip').addClass('recommended-goal-tip-hide');

    $registrationContainer.find('.js-goal-select').val(selectedGoal);

    $registrationContainer.find('.goal-selection-box.selected-goal').removeClass('selected-goal');

    var $newGoalBox = $input.parents('.goal-selection-box');
    $newGoalBox.addClass('selected-goal');

    var $container = $newGoalBox.parents('.goal-selection-boxes-wrapper');
    var offset = $newGoalBox.position().left + $container[0].scrollLeft - 16;

    $container.animate({
      scrollLeft: offset
    }, 250);
    addViewedGoal(selectedGoal);
  });

  $registrationContainer.find('.goal-selection-box').click(function () {
    var $input = $(this).find('.radio-box input');
    $input.prop('checked', true);
    $input.change();
  });

  $registrationContainer.find('.terms-and-conditions-link').click(function () {
    this.readTerms = true;
  });
})(window, jQuery);
